import { createMuiTheme } from '@material-ui/core/styles';

// Theme
const Theme = createMuiTheme({
	palette: {
		primary: {
			main: '#0a0a0a'
		},
		secondary: {
			main: '#f07913'
		}
	}
});

export default Theme;



// WEBPACK FOOTER //
// ./src/components/Theme.js